import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { from } from 'rxjs';
import { LinkService } from '../../../_services/langhfre.service';
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-language-services-publishing-and-media',
  templateUrl: './language-services-publishing-and-media.component.html',
  styleUrls: ['./language-services-publishing-and-media.component.scss']
})
export class LanguageServicesPublishingAndMediaComponent implements OnInit {

  email: any;
  // emailEnterprise : FormGroup;
  contactForm: FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;
  constructor(
    private toastr: ToastrService,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private router: Router,
    public loadScript: LoadScriptService
  ) {
    
  }

  ngOnInit() {
    this.titleService.setTitle("Trinka Enterprise｜言語サービス　出版　メディア");
    this.metaTagService.updateTag({ name: 'description', content: "チーム全体での英文ライティングの統一感を確保し、出版や記事の公開をスピードアップ。執筆の時間とコストを削減しながら読者体験の高い英語コンテンツを作成できます。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinka Enterprise｜言語サービス　出版　メディア" });
    this.metaTagService.updateTag({ property: 'og:description', content: "チーム全体での英文ライティングの統一感を確保し、出版や記事の公開をスピードアップ。執筆の時間とコストを削減しながら読者体験の高い英語コンテンツを作成できます。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/enterprise/language-services-publishing-and-media' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/language-services-publishing-and-media.png' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka Enterprise｜言語サービス　出版　メディア' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "チーム全体での英文ライティングの統一感を確保し、出版や記事の公開をスピードアップ。執筆の時間とコストを削減しながら読者体験の高い英語コンテンツを作成できます。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/language-services-publishing-and-media.png' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/language-services-publishing-and-media' });

    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      // document.getElementById('main_header').classList.add('homepageHeader');
      $.getScript('../../../../assets/js/hubslider.js', function () { });
      $.getScript('../../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../../assets/js/wisepop.js', function () { });
      $.getScript('../../../../assets/js/home_client_slider.js', function () { });
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }
  
}
